<script setup lang="ts">
import { readItems } from '@directus/sdk'
// import { Carousel, Pagination, Slide } from 'vue3-carousel'
// import 'vue3-carousel/dist/carousel.css'

import { register } from 'swiper/element/bundle'
import { useSwiper } from 'swiper/vue';
register()
const {
  d,
  locale: current_locale,
  locales,
  n,
  t,
} = useI18n({
  useScope: 'local',
})

// let testimonials = [
//   {
//     name: 'Jeroen',
//     text: 'Geweldige ervaring, zeker een aanrader!',
//   },
//   {
//     name: 'bob',
//     text: 'Zeer goede service, altijd op tijd en vriendelijk personeel',
//   },
//   {
//     name: 'jeff',
//     text: 'Leuke ervaring, zeker voor herhaling vatbaar',
//   },
//   {
//     name: 'zatte harry',
//     text: 'Tof om te doen met vrienden, zeker een aanrader!',
//   },
// ]

const { request } = useDirectusRest()
const swiper = ref()


const { data: testimonials } = await useAsyncData("testimonial", () => request(
  readItems('testimonial', {
    deep: {
      translations: {
        _filter: {
          languages_code: {
            _eq: current_locale.value,
          },
        },
      },
    },
    fields: ['id', 'name', 'translations.text', 'translations.languages_code'],
  })),
  {
    watch: [current_locale],
    transform: (data) => {

      return data.filter((testimonial) => testimonial.translations.length > 0 && testimonial.translations[0].text != null && testimonial.translations[0].text != '')
    }
  },
)
watch(() => testimonials.value, () => {
  swiper.value.swiper.update()
})
</script>

<template>
  
  <div class="max-w-screen w-full overflow-auto">
    <ClipAngle angle="right" background="white" foreground="sunglow-500" />
    <footer class="footer bg-sunglow-500 px-5 py-12 md:px-0">
      <div class="relative flex items-center justify-center">
        <img alt=""
          class="absolute left-4 translate-y-1/2 mix-blend-multiply md:translate-y-0 lg:relative hidden sm:block"
          src="/img/hartje.svg" />
        <div class="relative w-full max-w-3xl px-8 md:w-2/3 lg:w-full lg:px-0" :key="`slider-${current_locale}`">
          <swiper-container ref="swiper" :auto-height="true" :autoplay="{
            delay: 5000,
          }" :loop="true" :pagination="true">
            <swiper-slide v-for="item in testimonials">
              <div :style="{
                textWrap: 'pretty',
              }" class="flex h-[200px] w-full flex-col items-center justify-center">
                <p class="text-xl font-bold italic md:text-3xl">
                  {{ item.translations[0]?.text }}
                </p>
                <p class="text-sm md:text-base">
                  {{ item.name }}
                </p>
              </div>
            </swiper-slide>
          </swiper-container>
        </div>
      </div>
      <div class="mx-auto mt-36 flex max-w-5xl items-center justify-between">
        <div class="text-xs">
          <p>Copyright © FeestFiets {{ $dayjs().year() }}</p>
          <p>
            <NuxtLink class="underline" target="_blank" to="/FeestFiets_AlgemeneVoorwaarden.pdf">
              {{ t('terms_of_service') }}
            </NuxtLink>
            /
            <NuxtLink class="underline" target="_blank" to="/FeestFiets_BestuurdersVerklaring.pdf">
              {{ t('drivers_declaration') }}
            </NuxtLink>
          </p>
        </div>
        
        <div class="flex gap-3">
          <NuxtLink
            class="grid h-14 w-14 place-items-center rounded-full bg-black text-sunglow duration-150 hover:bg-white hover:text-black"
            external target="_blank" to="https://www.facebook.com/feestfiets/">
            <Icon name="fa6-brands:facebook-f" size="30" />
          </NuxtLink>
          <NuxtLink
            class="grid h-14 w-14 place-items-center rounded-full bg-black text-sunglow duration-150 hover:bg-white hover:text-black"
            external target="_blank" to="https://www.instagram.com/explore/tags/feestfiets/">
            <Icon name="fa6-brands:instagram" size="30" />
          </NuxtLink>
        </div>
      </div>
    </footer>
  </div>
</template>

<style>
swiper-container::part(bullet-active) {
  @apply bg-black w-6 h-2 rounded-full duration-100 transition-all;
}

swiper-container::part(bullet) {
  @apply w-4 h-2 rounded-md duration-100 transition-all;
}

swiper-container::part(pagination) {
  margin-top: 50px;
}
</style>

<i18n lang="json">
{
  "nl": {
    "terms_of_service": "Algemene voorwaarden",
    "drivers_declaration": "Bestuurdersverklaring"
  },
  "en": {
    "terms_of_service": "Terms of service",
    "drivers_declaration": "Drivers declaration"
  },
  "fr": {
    "terms_of_service": "Conditions générales",
    "drivers_declaration": "Déclaration du conducteur"
  }
}
</i18n>
